// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';

export const updateFormValidation = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_FORM_VALIDATION,
    validity: mapFormValidation(property, value)
});

export const updateWorkOrderOne = workOrderOne => ({
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_ONE,
    workOrderOne
});

export const updateWorkOrderTwo = workOrderTwo => ({
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_WORK_ORDER_TWO,
    workOrderTwo
});

export const updateMethodOfContact = (key, options) => ({
    key,
    options,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT
});

export const updateContactDate = date => ({
    date,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_CONTACT_DATE
});

export const updateRelationship = (key, options) => ({
    key,
    options,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP
});

export const updateFirstName = firstName => ({
    firstName,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_FIRST_NAME
});

export const updateLastName = lastName => ({
    lastName,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_LAST_NAME
});

export const updateEMail = eMail => ({
    eMail,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_E_MAIL
});

export const updateClaimQuestionChoice = (index, choice) => ({
    choice,
    index,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_QUESTION_CHOICE
});

export const updateStickyHeaderVisibility = status =>
    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_STICKY_HEADER_VISIBILITY
        });

    };

export const resetClaim = () => ({
    type: actions.RESET_CLAIM_MCC_FOLLOWUP
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/claim-details.js